import White1 from '../White Rose/White Rose (1).webp'
import White2 from '../White Rose/White Rose (2).webp'
import White3 from '../White Rose/White Rose (3).webp'
import White4 from '../White Rose/White Rose (4).webp'
import White5 from '../White Rose/White Rose (5).webp'
import White6 from '../White Rose/White Rose (6).webp'
import White7 from '../White Rose/White Rose (7).webp'
import White8 from '../White Rose/White Rose (8).webp'
import White9 from '../White Rose/White Rose (9).webp'


const Whiteimages =[
White1,White2,White3,White4,White5,White6,White7,White8,White9
]

export default Whiteimages;